import { render, staticRenderFns } from "./SeatMap.vue?vue&type=template&id=512d5e28&scoped=true&"
import script from "./SeatMap.vue?vue&type=script&lang=js&"
export * from "./SeatMap.vue?vue&type=script&lang=js&"
import style0 from "./SeatMap.vue?vue&type=style&index=0&id=512d5e28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512d5e28",
  null
  
)

export default component.exports